module.exports = __webpack_public_path__ + "static/media/DocsButton.7b4652a3.svg";